import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M0 5.33333H5.33333V0H0V5.33333ZM1.33333 1.33333H4V4H1.33333V1.33333Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M0 12.0013H5.33333V6.66797H0V12.0013ZM1.33333 8.0013H4V10.668H1.33333V8.0013Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.66675 0V5.33333H12.0001V0H6.66675ZM10.6667 4H8.00008V1.33333H10.6667V4Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12.0001 10.668H10.6667V12.0013H12.0001V10.668Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8.00008 6.66797H6.66675V8.0013H8.00008V6.66797Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.33333 8H8V9.33333H9.33333V8Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8.00008 9.33203H6.66675V10.6654H8.00008V9.33203Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.33333 10.668H8V12.0013H9.33333V10.668Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.6666 9.33203H9.33325V10.6654H10.6666V9.33203Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.6666 6.66797H9.33325V8.0013H10.6666V6.66797Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12.0001 8H10.6667V9.33333H12.0001V8Z" })
	]
});
export default SvgQrIcon;
